
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"114","height":"108","viewBox":"0 0 114 108","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.341 0c24.815.058 47.271 15.604 54.586 39.147 7.011 22.562-4.457 45.955-23.935 59.497-18.4 12.793-42.545 12.306-60.951-.478C7.486 84.585-5.035 61.545 1.958 38.89 9.283 15.16 32.343-.058 57.341 0z","fill":"currentColor"}})])
          )
        }
      }
    